
/*
=============================================================================
auto-generated ***
to refresh you will need to run
npm run build:model
This code was generated by a tool.
¯\_(ツ)_/¯

Changes to this file may cause incorrect behavior and will be lost if
the code is regenerated.
=============================================================================
*/

export type TOptionSetNames = "bcbs_accidentaldentalinjury" |
	"bcbs_accidentbenefits" |
	"bcbs_accounttypecode" |
	"bcbs_actionitemfiltercode" |
	"bcbs_actionitemtriggercode" |
	"bcbs_actionitemtypecode" |
	"bcbs_activeenrollment" |
	"bcbs_acupchk" |
	"bcbs_adminfeesbillingtypecode" |
	"bcbs_agentrole" |
	"bcbs_agenttypeofbusinesscode" |
	"bcbs_aggregatedeductibletype" |
	"bcbs_aggregateooptype" |
	"bcbs_applicabilitycode" |
	"bcbs_approvalrequiredstate" |
	"bcbs_arfeetype" |
	"bcbs_aso_ded_is_ded" |
	"bcbs_aso_ded_oop_is_oop" |
	"bcbs_asodependentmaternity" |
	"bcbs_attributetypecode" |
	"bcbs_barsurchk" |
	"bcbs_bcbs_privnurschk" |
	"bcbs_bccratetype" |
	"bcbs_bdsautomationstatuscode" |
	"bcbs_benefitissue" |
	"bcbs_benefitstatus" |
	"bcbs_benefityeartypecode" |
	"bcbs_billingmethodcode" |
	"bcbs_billterminationfeesto" |
	"bcbs_bluecardoption" |
	"bcbs_calc_ambulanceooplimit" |
	"bcbs_calc_diagserviceslabooplimit" |
	"bcbs_calc_diagservicesradooplimit" |
	"bcbs_calc_dmeooplimit" |
	"bcbs_calc_emerdepartmentooplimit" |
	"bcbs_calc_inpathoscareooplimit" |
	"bcbs_calc_medicalsuppliesooplimit" |
	"bcbs_calc_otcdrugsooplimit" |
	"bcbs_calc_otcmedsuppliesooplimit" |
	"bcbs_calc_otherfacilityservicesooplimit" |
	"bcbs_calc_otheritemsservicesooplimit" |
	"bcbs_calc_presdrugsbrandedooplimit" |
	"bcbs_calc_presdrugsgenericooplimit" |
	"bcbs_calc_prevservicesvaccinesooplimit" |
	"bcbs_calc_profservicesemerdepartmentooplimit" |
	"bcbs_calc_profservicesobsetriccareooplimit" |
	"bcbs_calc_profservicesprimcareooplimit" |
	"bcbs_calc_profservicesproceduresooplimit" |
	"bcbs_calc_profservicesptooplimit" |
	"bcbs_calc_profservicesspecialistooplimit" |
	"bcbs_calcdmetype" |
	"bcbs_calchosptype" |
	"bcbs_calcinputtypes" |
	"bcbs_calclabtype" |
	"bcbs_calcobgyntype" |
	"bcbs_calcprevtype" |
	"bcbs_calcradtype" |
	"bcbs_calcrxtype" |
	"bcbs_calcvisittype" |
	"bcbs_captype" |
	"bcbs_categoryset" |
	"bcbs_categoryvisibility" |
	"bcbs_certaindiagexclusion" |
	"bcbs_changetypecode" |
	"bcbs_chargetype" |
	"bcbs_chiro_mon_or_max" |
	"bcbs_chirochk" |
	"bcbs_claimissuetype" |
	"bcbs_claimsardefinition" |
	"bcbs_claimsarfees" |
	"bcbs_claimsbillingfrequency" |
	"bcbs_claimsbillingreportdeliverycode" |
	"bcbs_coinsurancemayapply" |
	"bcbs_complexitycode" |
	"bcbs_contractbasis" |
	"bcbs_contractbasiscode" |
	"bcbs_copaycoinsurancetypecode" |
	"bcbs_copaymentmayapply" |
	"bcbs_copayselectioncode" |
	"bcbs_corridor" |
	"bcbs_corridorcode" |
	"bcbs_cosmsurchk" |
	"bcbs_costsharetype" |
	"bcbs_coverednotcovered" |
	"bcbs_cranialexclusion" |
	"bcbs_creditbehaviorcode" |
	"bcbs_customerstatuscode" |
	"bcbs_deductiblemayapply" |
	"bcbs_deductibleoopfactorcode" |
	"bcbs_dentaldeductibletypecode" |
	"bcbs_dentcarechk" |
	"bcbs_dependentmaternity" |
	"bcbs_diabetes" |
	"bcbs_emiteventorigin" |
	"bcbs_emnotificationsendto" |
	"bcbs_employeraccounttype" |
	"bcbs_enablebasedoncode" |
	"bcbs_enhancedrecoverypercentagerawlings" |
	"bcbs_enrollsubro" |
	"bcbs_epo_aremhsubenefitscovered" |
	"bcbs_epo_chiropracticserviceslimitestoben" |
	"bcbs_epo_drgugsarecoveredunder" |
	"bcbs_epo_innetworkchirservices" |
	"bcbs_epo_orthognathicsurgeriescoveredat" |
	"bcbs_epo_outofnetworkchiro100out" |
	"bcbs_erisa" |
	"bcbs_erisacode" |
	"bcbs_excludedservices1" |
	"bcbs_excludedservices10" |
	"bcbs_excludedservices2" |
	"bcbs_excludedservices3" |
	"bcbs_excludedservices4" |
	"bcbs_excludedservices5" |
	"bcbs_excludedservices6" |
	"bcbs_excludedservices7" |
	"bcbs_excludedservices8" |
	"bcbs_excludedservices9" |
	"bcbs_faqtypecode" |
	"bcbs_fi_ppocompanionchooseone" |
	"bcbs_finalist" |
	"bcbs_flushotsagelimit" |
	"bcbs_foodsuppliments" |
	"bcbs_frequencycode" |
	"bcbs_fundingtypes" |
	"bcbs_gcfundingtypecode" |
	"bcbs_gcseventtypeid" |
	"bcbs_generationstatuscode" |
	"bcbs_generic_incentive_program_options" |
	"bcbs_genericmailtieroption" |
	"bcbs_genericretailtieroption" |
	"bcbs_glprocessstatecode" |
	"bcbs_grandfathered" |
	"bcbs_grandfatheredcode" |
	"bcbs_groupconfigurationchangetypecode" |
	"bcbs_grouplitigationfee" |
	"bcbs_grouprole" |
	"bcbs_grouptypecode" |
	"bcbs_growthhormone" |
	"bcbs_grpconfigservicecenterclaimsprocessing" |
	"bcbs_hcr_accidental_dental" |
	"bcbs_healthoptions" |
	"bcbs_hearaidchk" |
	"bcbs_hemophilia" |
	"bcbs_hhdpaggembedcode" |
	"bcbs_hiatypecode" |
	"bcbs_hottexclusion" |
	"bcbs_hypnotismexclusion" |
	"bcbs_idcardorderingoptioncode" |
	"bcbs_ifinandoutofnetworkpaythesameoonbyamb" |
	"bcbs_ifinandoutofnetworkpaythesameoonbydsa" |
	"bcbs_immunizationsagelimit" |
	"bcbs_infertchk" |
	"bcbs_internalactiontypes" |
	"bcbs_ispreauthorizationrequiredfordmeprostheti" |
	"bcbs_ispreauthrequired" |
	"bcbs_issuecategory" |
	"bcbs_jeopardycategorycode" |
	"bcbs_laseredexcluded" |
	"bcbs_lineitemtypecode" |
	"bcbs_lob" |
	"bcbs_ltcchk" |
	"bcbs_manuallyeditedpdf" |
	"bcbs_maternity" |
	"bcbs_medicaldeductibletype" |
	"bcbs_medicaldeductibletypecode" |
	"bcbs_minimumessentialcoverage" |
	"bcbs_minimumvaluestandards" |
	"bcbs_monthlyannual" |
	"bcbs_net_prov_yn" |
	"bcbs_nonemergchk" |
	"bcbs_nonpreferredmailtieroption" |
	"bcbs_nonpreferredretailtieroption" |
	"bcbs_nonstandard_applyto" |
	"bcbs_numberoftiers" |
	"bcbs_numtiers" |
	"bcbs_opportunitybenefittemplatetype" |
	"bcbs_opportunityoutcome" |
	"bcbs_opportunityproductpreventivebenefitcode" |
	"bcbs_opportunityproducttype" |
	"bcbs_opportunityproducttypecode" |
	"bcbs_opportunityproductuwstatuscode" |
	"bcbs_opportunitytowinrenewcode" |
	"bcbs_opportunitytypecode" |
	"bcbs_orthognathic" |
	"bcbs_outofpockettype" |
	"bcbs_partnerplan" |
	"bcbs_partnerplancode" |
	"bcbs_partnerplanstatuscode" |
	"bcbs_paymentmethodadminfeescode" |
	"bcbs_paymentmethodforclaimscodes" |
	"bcbs_pbmtype" |
	"bcbs_pdexclusion" |
	"bcbs_percentordollarcode" |
	"bcbs_perlifetimepercontractyear" |
	"bcbs_pgcodedetailunitx" |
	"bcbs_pgcodedetailunity" |
	"bcbs_pgdeliveryfrequency" |
	"bcbs_pgmeasurefrequency" |
	"bcbs_pgreadwhat" |
	"bcbs_pgtype" |
	"bcbs_pharmacyformulary" |
	"bcbs_plan_type" |
	"bcbs_portalissuestatuschange" |
	"bcbs_posteriorfillingscode" |
	"bcbs_preferredmailtieroption" |
	"bcbs_preferredretailtieroption" |
	"bcbs_processstatecode" |
	"bcbs_productsatriskcode" |
	"bcbs_producttypecode" |
	"bcbs_productvisibilitycode" |
	"bcbs_prostheticce" |
	"bcbs_prostheticexclusion" |
	"bcbs_pulmonaryexclusion" |
	"bcbs_quoterequeststatuscode" |
	"bcbs_reasonforquotecode" |
	"bcbs_relationshipprioritycode" |
	"bcbs_relationshiptypecode" |
	"bcbs_reportfrequency" |
	"bcbs_reportresubmissionreason" |
	"bcbs_reportscriptingtype" |
	"bcbs_requestaccess" |
	"bcbs_requestdatautilization" |
	"bcbs_requiredforvalidationcode" |
	"bcbs_residentialtreatmentcenters" |
	"bcbs_routineeyechk" |
	"bcbs_routinefootchk" |
	"bcbs_routinephyagelimit" |
	"bcbs_runoutfees" |
	"bcbs_rx_generic_mail_separaterxded" |
	"bcbs_rx_generic_retail_separaterxded" |
	"bcbs_rx_integrateonmedicaldeductible" |
	"bcbs_rx_nonpreferred_mail_separaterxded" |
	"bcbs_rx_nonpreferred_retail_separaterxded" |
	"bcbs_rx_preferred_mail_separaterxded" |
	"bcbs_rx_preferred_retail_separaterxded" |
	"bcbs_rx_specialty_separaterxded" |
	"bcbs_salesstatuscode" |
	"bcbs_salestransitionstatuscode" |
	"bcbs_sbcconfig_tablocation" |
	"bcbs_sbclog_function" |
	"bcbs_sbcstatus" |
	"bcbs_sbctype" |
	"bcbs_servicescoveredbeforeded" |
	"bcbs_servicingoffices" |
	"bcbs_sharedsavingscap" |
	"bcbs_sharedsavingscategory" |
	"bcbs_sharedsavingssspicomponent" |
	"bcbs_snc_yn" |
	"bcbs_spec_cov_rules_std_ben_smoking" |
	"bcbs_spec_ref_yn" |
	"bcbs_specialtydrugnetworks" |
	"bcbs_ss_ded_ans" |
	"bcbs_standardcopaycode" |
	"bcbs_status" |
	"bcbs_statuscode" |
	"bcbs_stoplossadministrator" |
	"bcbs_stoplossautoreimbursement" |
	"bcbs_stoplosscontractbasis" |
	"bcbs_stoplosscoverage" |
	"bcbs_stoplosstypecode" |
	"bcbs_subrogation" |
	"bcbs_subrogationpaymentmethod" |
	"bcbs_teamrolecode" |
	"bcbs_tiercode" |
	"bcbs_tiertypecode" |
	"bcbs_transactiontypecode" |
	"bcbs_usertypecode" |
	"bcbs_valuetypecode" |
	"bcbs_varicoseexclusion" |
	"bcbs_weightlosschk" |
	"bcbs_writeintypecharges" |
	"bcbs_yesnooptionset" |
	null;

export const bcbs_fundingtypes = {
	"AdministrativeServicesOnly": {
		name: "Administrative Services Only",
		value: 808900000
	},
	"ASOwithStopLoss": {
		name: "ASO with Stop Loss",
		value: 808900001
	},
	"FullyInsured": {
		name: "Fully Insured",
		value: 808900002
	},
	"NationalAlliance": {
		name: "National Alliance",
		value: 808900003
	},
	"LevelFunded": {
		name: "Level Funded",
		value: 808900004
	},
}

export const bcbs_groupconfigurationchangetypecode = {
	"InitialSetup": {
		name: "Initial Setup",
		value: 808900002
	},
	"ComprehensiveRenewal": {
		name: "Comprehensive Renewal",
		value: 808900001
	},
	"BenefitRenewal": {
		name: "Benefit Renewal",
		value: 808900010
	},
	"FinancialRenewal": {
		name: "Financial Renewal",
		value: 808900011
	},
	"ComprehensiveChange": {
		name: "Comprehensive Change",
		value: 808900004
	},
	"BenefitChange": {
		name: "Benefit Change",
		value: 808900000
	},
	"FinancialChange": {
		name: "Financial Change",
		value: 808900006
	},
	"StopLoss": {
		name: "Stop Loss",
		value: 808900009
	},
	"AdministrativeChange": {
		name: "Administrative Change",
		value: 808900003
	},
	"MNILInitialSetupContinuation": {
		name: "MNIL - Initial Setup Continuation",
		value: 808900005
	},
	"MNILRenewalContinuation": {
		name: "MNIL - Renewal Continuation",
		value: 808900008
	},
	"MNILBenefitChangeContinuation": {
		name: "MNIL - Benefit Change Continuation",
		value: 808900007
	},
	"MNILComprehensiveChangeContinuation": {
		name: "MNIL - Comprehensive Change Continuation",
		value: 808900013
	},
	"MNILComprehensiveRenewalContinuation": {
		name: "MNIL - Comprehensive Renewal Continuation",
		value: 808900014
	},
	"PSAChange": {
		name: "PSA Change",
		value: 808900012
	},
	"PostCancelUpdate": {
		name: "Post Cancel Update",
		value: 808900015
	},
}

export const bcbs_lob = {
	"FEP": {
		name: "FEP",
		value: 808900006
	},
	"GIDeprecated": {
		name: "G&I [Deprecated]",
		value: 808900000
	},
	"StateGroup": {
		name: "State Group",
		value: 808900005
	},
	"MajorGroup": {
		name: "Major Group",
		value: 808900003
	},
	"NationalAlliance": {
		name: "National Alliance",
		value: 808900001
	},
	"BlueChoice": {
		name: "BlueChoice",
		value: 808900002
	},
	"GI": {
		name: "G&I",
		value: 808900004
	},
}

